import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appLink',
  label: 'External Links',
  isDragable: false,
  canChangePosition: true,
  sortingPositionIndex: 'sortingIndex',
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  isMultiSelectable:false,
  emptyMessage: "You don't have external links, click on the \"+\" icon to create one.",

  newButton:false,
  createURL:'appId/areaId/appExternalLinks',
  // editURL:'graphicmanagers/resource',
  getURL:'appId/areaId/appExternalLinks',
  updateURL:'appId/areaId/appExternalLinks',
  removeURL:'appId/areaId/appExternalLinks',
  sessionParams: ['appId', 'areaId'],

  deleteRecordText:"You are about to delete the external link. Do you still want to proceed?",
  // popupContentFormNew:[formGraphicManagerVODManifestContent],
  // popupContentFormEdit:[formGraphicManagerVODManifestContent],
  // popupContentFormSecondary:[formSportRoomConfigContentMassUpdate],
  
  fields: [
    
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the link.',
    },
    {
      attributeName: 'url',
      label: 'URL',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'URL of the link.',
    },
  ],
};
